// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
declare let EnvConf;

export const environment = {
  // production: false,
  production: false,
  url: {
    api: EnvConf.apiOrigin,
    interceptorRegExp: EnvConf.interceptorRegExp,
  },
  languages: (EnvConf.languages && EnvConf.languages.split(',')) || [],
  locale: EnvConf.locale,
  appInsights: {
    instrumentationKey: EnvConf.appInsightsKey,
  },
  trackingID: EnvConf.trackingID,
  googleReCaptcha: {
    siteKey: EnvConf.googleReCaptchaKey,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

